import { render } from "./UserList.vue?vue&type=template&id=1efc9de6&scoped=true"
import script from "./UserList.vue?vue&type=script&lang=js"
export * from "./UserList.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1efc9de6"

export default script